module.exports = __webpack_public_path__ + "img/gamstop-greyscale.fe7f03f7.svg";